import React from "react";
import cv from "./files/cv.pdf";

const Hero = () => (
  <section className="hero wrap" id="top">
    <p className="hero-kicker">
      <span className="dot">●</span>
      Elad Hodeda — Algorithm &amp; Embedded Engineer
    </p>
    <h1 className="hero-title">
      Algorithms for the <em>physical world</em>.
    </h1>
    <p className="hero-sub">
      Signal processing and algorithm engineer with 3+ years building
      navigation and detection systems for the IDF Ground Forces, and FMCW
      Lidar validation experience at Mobileye. Currently studying
      Mathematics &amp; Computer Science at the Open University of Israel.
    </p>
    <div className="hero-actions">
      <a
        className="btn"
        href="https://github.com/EH127"
        target="_blank"
        rel="noreferrer"
      >
        GitHub ↗
      </a>
      <a
        className="btn"
        href="https://www.linkedin.com/in/eladhodeda"
        target="_blank"
        rel="noreferrer"
      >
        LinkedIn ↗
      </a>
      <a className="btn btn-solid" href={cv} download="elad-hodeda-cv.pdf">
        Download CV ↓
      </a>
    </div>
    <p className="hero-status">
      Status: open to work&ensp;·&ensp;GPS: locked&ensp;·&ensp;IMU: calibrated
    </p>
  </section>
);

export default Hero;
